/**
 * Custom logging utility that provides styled console output when debugging is enabled.
 * Supports regular logging, collapsible groups, and table formatting with color-coded status styles.
 * Only outputs logs when DEBUG flag is true.
 */
(function (g) {
  const DEBUG = true || window.Shopify?.theme?.role === 'development' || window.Shopify?.theme?.role === 'unpublished',
    styles = {
      success: "background:darkgreen;color:white;padding:2px 6px;border-radius:3px",
      error: "background:darkred;color:white;padding:2px 6px;border-radius:3px",
      warning: "background:darkorange;color:white;padding:2px 6px;border-radius:3px",
      info: "background:blue;color:white;padding:2px 6px;border-radius:3px",
      filename: "background:#333;color:#bada55;padding:2px 6px;border-radius:3px;margin-left:4px"
    };

  const getCallerFile = () => {
    try {
      return (new Error().stack.split('\n').find(l => (l.includes('/assets/') || l.includes('/sections/') || l.includes('/snippets/')) && !l.includes('/custom_sitewide.js') || !l.includes('jquery-')) || '')
        .match(/\/(assets|sections|snippets)\/([^:?]+)\??/)?.[2] || '';
    } catch (e) { return ''; }
  };

  const log = (...args) => DEBUG && console.log(...args);

  const collapse = (type, data, title = "Log", status = "info") => {
    if (!DEBUG) return;
    const file = getCallerFile();
    console.groupCollapsed(`%c ${title}${file ? ' %c' + file : ''}`,
      styles[status] || styles.info, file ? styles.filename : '');
    type === "table" ? console.table(data) : console.log(data);
    console.groupEnd();
  };

  log.table = (data, title, status) => collapse("table", data, title, status);
  log.collapse = (data, title, status) => collapse("log", data, title, status);
  g.log = log;
})(typeof window !== "undefined" ? window : globalThis);

const log = window.log;

/**
 * The function `updatePagination` calculates and displays the current page number out of total pages
 * for a carousel using Slick slider.
 * @returns The `updatePagination` function is returning the current page number and total page count
 * in the pagination element.
 */
function updatePagination(carousel) {
  const $pagination = carousel.siblings('.slick-pagination');
  if (!$pagination.length) return;

  function setPagination() {
    const slick = carousel.slick('getSlick');
    if (!slick) return;
    const sToShow = +slick.options.slidesToShow || 1;
    const sToScroll = +slick.options.slidesToScroll || sToShow;
    const total = +slick.slideCount || 0;
    let pages = total > sToShow ? Math.ceil(total / sToScroll) : 1;
    let curr = total > sToScroll ? Math.floor(slick.slickCurrentSlide() / sToScroll) + 1 : 1;
    $pagination.text(`${curr}/${pages}`);
  }

  carousel.on('afterChange', setPagination);
  setPagination();
}


/**
 * Initializes and manages a Slick carousel with separate mobile and desktop configurations.
 * Ensures no unnecessary reinitialization during window resizing.
 *
 * @param {jQuery} carousel - The carousel element(s).
 * @param {Object} mobileOptions - Slick options for mobile view.
 * @param {number} breakpoint - The breakpoint to switch between mobile and desktop configurations.
 * @param {Object|null} desktopOptions - Slick options for desktop view. If null, unslick on desktop.
 */
function handleResponsiveCarousel(carousel, mobileOptions, breakpoint = 1024, desktopOptions = null) {
  let currentView = null; // Keeps track of the current view ('mobile' or 'desktop')

  function initializeCarousel() {
    const isDesktop = $(window).width() >= breakpoint;

    if (isDesktop) {
      if (currentView !== 'desktop') {
        if (carousel.hasClass('slick-initialized')) carousel.slick('unslick');
        if (desktopOptions) {
          carousel.slick(desktopOptions);
          updatePagination(carousel);
        }
        currentView = 'desktop';
      }
    } else {
      if (currentView !== 'mobile') {
        if (carousel.hasClass('slick-initialized')) carousel.slick('unslick');
        carousel.slick(mobileOptions);
        updatePagination(carousel);
        currentView = 'mobile';
      }
    }
  }

  initializeCarousel();
  $(window).on('resize', function () {
    initializeCarousel();
  });
}

// Function to copy text to clipboard
function copyToClipboard(text) {
  var $tempInput = $("<input>");
  $("body").append($tempInput);
  $tempInput.val(text).select();
  document.execCommand("copy");
  $tempInput.remove();
}
function showCopyNotification() {
  const $n = $('<div class="copy-notification">Copied!</div>').appendTo('body');
  setTimeout(() => $n.css({ opacity: 1, transform: 'translateY(0)' }), 10);
  setTimeout(() => { $n.css({ opacity: 0, transform: 'translateY(20px)' }); setTimeout(() => $n.remove(), 200); }, 1500);
}


$(document).ready(function () {
  $('a[href="#"][title="Copy to Clipboard"]').on('click', function (e) {
    e.preventDefault();
    const text = $(this).data('copy') || $(this).text().trim();
    copyToClipboard(text);
    showCopyNotification();
    log.collapse({ text, parent: $(this).parent().parent() }, 'Copied to Clipboard', 'success');
  });

  const useChevron = false;
  const icons = {
    arrow_left: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_Left.svg?v=1744058170',
    arrow_right: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_Right.svg?v=1744058170',
    chevron_left: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/chevron_left.svg?v=1745952252',
    chevron_right: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/chevron_right.svg?v=1745952252',
    chevron_left_white: 'https://cdn.shopify.com/s/files/1/0499/3902/1985/files/slider_arrow_new_left_white.svg?v=1751497822',
    chevron_right_white: 'https://cdn.shopify.com/s/files/1/0499/3902/1985/files/slider_arrow_new_right_white.svg?v=1751497822',
  };
  const buttons = {
    prevArrow: `<button type='button' aria-label='Arrow Left' class='slick-prev pull-left'><img class='left_arrow' src='${useChevron ? icons.chevron_left : icons.arrow_left}' alt='arrow'/></button>`,
    nextArrow: `<button type='button' aria-label='Arrow Right' class='slick-next pull-right'><img class='right_arrow' src='${useChevron ? icons.chevron_right : icons.arrow_right}' alt='arrow'/></button>`,
    prevArrowChevron: `<button type='button' aria-label='Arrow Left' class='slick-prev pull-left'><img class='left_arrow' src='${icons.chevron_left}' alt='arrow'/></button>`,
    nextArrowChevron: `<button type='button' aria-label='Arrow Right' class='slick-next pull-right'><img class='right_arrow' src='${icons.chevron_right}' alt='arrow'/></button>`,
    prevArrowChevronWhite: `<button type='button' aria-label='Arrow Left' class='slick-prev pull-left'><img class='left_arrow' src='${icons.chevron_left_white}' alt='arrow'/></button>`,
    nextArrowChevronWhite: `<button type='button' aria-label='Arrow Right' class='slick-next pull-right'><img class='right_arrow' src='${icons.chevron_right_white}' alt='arrow'/></button>`
  }

  $('.testimonials__cards').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '40px',
    arrows: true,
    dots: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          centerPadding: '30px'
        }
      }
    ]
  });


  $('.testimonials .testimonials.product_reviews').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ],
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow
  });

  $('.jsFeaturedCollection .featured-collection').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      }
    ],
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow
  });


  $('.gallery__wrapper').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.video-reviews__wrapper').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    variableWidth: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    customPaging: function (slider, i) {
      return '<div class="slick-pagination">' + (i + 1) + '</div>';
    },
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  updatePagination($('.video-reviews__wrapper'));

  $('.pr-item__product-images.gallery-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
  });

  $('.product-showcase__products.pdp-description').slick({
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 2,
    slidesToScroll: 2
  });

  $('.pr-reviews__reviews--slick').slick({
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: buttons.prevArrowChevron,
    nextArrow: buttons.nextArrowChevron,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '16px',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  $('.pdp-main__images .product-images:not(.thumbnails)[data-images="all"]').slick({
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: buttons.prevArrowChevronWhite,
    nextArrow: buttons.nextArrowChevronWhite,
    slidesToShow: 1,
    slidesToScroll: 1,
       asNavFor: $('.pdp-main__images').hasClass('thumbnails-free-scroll') ? null : $('.pdp-main__images:not(.thumbnails-free-scroll) .product-images.thumbnails[data-images="all"]')
  });
  $('.pdp-main__images:not(.thumbnails-free-scroll) .product-images.thumbnails[data-images="all"]').slick({
    infinite: true,
    dots: false,
    arrows: false,
    prevArrow: buttons.prevArrowChevronWhite,
    nextArrow: buttons.nextArrowChevronWhite,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.pdp-main__images .product-images:not(.thumbnails)[data-images="all"]'
  });
  $('.pdp-main__images.thumbnails-free-scroll .product-images.thumbnails').each(function () {
    const container = $(this);
    let isDown = false;
    let startX;
    let scrollLeft;

    // Prevent image dragging
    container.find('img, video').attr('draggable', false);

    // Mouse events for scrolling
    container
      .on('mousedown', function (e) {
        isDown = true;
        container.addClass('grabbing');
        startX = e.pageX;
        scrollLeft = container.scrollLeft();
        e.preventDefault();
      })
      .on('touchstart', function (e) {
        isDown = true;
        container.addClass('grabbing');
        startX = e.originalEvent.touches[0].pageX;
        scrollLeft = container.scrollLeft();
      })
      .on('mouseleave mouseup', function () {
        isDown = false;
        container.removeClass('grabbing');
      })
      .on('touchend touchcancel', function () {
        isDown = false;
        container.removeClass('grabbing');
      })
      .on('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX;
        const walk = (startX - x) * 1.5;
        container.scrollLeft(scrollLeft + walk);
      })
      .on('touchmove', function (e) {
        if (!isDown) return;
        const x = e.originalEvent.touches[0].pageX;
        const walk = (startX - x) * 1.5;
        container.scrollLeft(scrollLeft + walk);
        e.preventDefault(); // Prevent page scrolling while dragging thumbnails
      });

    // Click on thumbnails to navigate
    container.on('click', 'div:not(.product-image):has(> video, > img, > .product-image[data-type="video"])', function () {
      if (isDown) return; // Don't trigger click when dragging
      const index = $(this).data('index');
      $('.pdp-main__images .product-images.slick-initialized[data-images="all"]')
        .slick('slickGoTo', index);
    });
  });

  $('.draggable-slider').each(function () {
    const slider = $(this);
    let isDown = false;
    let startX;
    let scrollLeft;

    // Prevent image dragging
    slider.find('img').attr('draggable', false);

    // Mouse events for scrolling
    slider
      .on('mousedown', function (e) {
        isDown = true;
        slider.addClass('grabbing');
        startX = e.pageX;
        scrollLeft = slider.scrollLeft();
        e.preventDefault();
      })
      .on('touchstart', function (e) {
        isDown = true;
        slider.addClass('grabbing');
        startX = e.originalEvent.touches[0].pageX;
        scrollLeft = slider.scrollLeft();
      })
      .on('mouseleave mouseup', function () {
        isDown = false;
        slider.removeClass('grabbing');
      })
      .on('touchend touchcancel', function () {
        isDown = false;
        slider.removeClass('grabbing');
      })
      .on('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX;
        const walk = (startX - x) * 1.5;
        slider.scrollLeft(scrollLeft + walk);
      })
      .on('touchmove', function (e) {
        if (!isDown) return;
        const x = e.originalEvent.touches[0].pageX;
        const walk = (startX - x) * 1.5;
        slider.scrollLeft(scrollLeft + walk);
        e.preventDefault(); // Prevent page scrolling while dragging
      });
  });
  // $('.pdp-main__images .product-images[data-images="remaining"].thumb').slick({
  //   infinite: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   dots: false,
  //   variableWidth: false
  // });

  const TPReviews = $('.tp-reviews__cards');
  const TPRevewsOptions = {
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true
  };
  const TPRevewsDesktopOptions = $('.tp-reviews__cards.desktop-carousel').length ? {
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 3,
    slidesToScroll: 3
  } : null;

  const ProductShowcase = $('.product-showcase__products:not(.pdp-description)');
  const ProductShowcaseOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 2,
    slidesToScroll: 2
  };

  handleResponsiveCarousel(TPReviews, TPRevewsOptions, 1024, TPRevewsDesktopOptions);
  handleResponsiveCarousel(ProductShowcase, ProductShowcaseOptions, 753);

  // Video reviews --------------------------------------------------------
  $('.video-reviews__video-button.play, .video-reviews__video').click(function () {
    const $videoWrapper = $(this).is('.video-reviews__video') ? $(this) : $(this).closest('.video-reviews__video');
    const $video = $videoWrapper.find('video');

    if ($video.length) {
      if (!$video.get(0).paused) {
        $video.get(0).pause();
        $videoWrapper.removeClass('play').find('.video-reviews__video-button.pause').hide();
        $videoWrapper.find('.video-reviews__video-button.play').css('display', 'flex');
        return;
      }
      $('.video-reviews__video').each(function () {
        const $otherWrapper = $(this);
        const $otherVideo = $otherWrapper.find('video');
        if ($otherVideo.get(0) !== $video.get(0)) {
          $otherVideo.prop('muted', true).get(0).pause();
          $otherWrapper.removeClass('play').find('.video-reviews__video-button.play').css('display', 'flex');
          $otherWrapper.find('.video-reviews__video-button.pause').hide();
        }
      });

      $video.prop('muted', false).prop("volume", 0.5).get(0).play();
      $(this).is($videoWrapper) ? $videoWrapper.find('.video-reviews__video-button.play').hide() : $(this).hide();
      $videoWrapper.addClass('play').find('.video-reviews__video-button.pause').css('display', 'flex');
    }
  });
  $('.video-reviews__video-button.play').click(function (e) {
    e.stopPropagation();
  })


  // Announcement Timer
  function AnnouncementTimer() {
    const timerWrap = $('.announcement__timer');
    if (!timerWrap.length) return;

    const timer = timerWrap.find('.timer');
    let time;

    const timerDate = timerWrap.data('timer-date');
    if (timerDate) {
      const targetTime = new Date(timerDate + "T00:00:00"); // Local midnight of the given date
      time = Math.floor((targetTime - new Date()) / 1000); // Time difference in seconds
    } else {
      time = parseInt(timerWrap.data('time'), 10);
    }

    if (time <= 0) return timerWrap.hide(); // Ensures valid countdown

    const update = () => {
      if (time < 0) return timerWrap.hide();
      timer.text([Math.floor(time / 3600), Math.floor((time % 3600) / 60), time % 60]
        .map(v => v.toString().padStart(2, '0')).join(':'));
      time--;
    };

    update();
    setInterval(update, 1000);
  }

  // Easter Banner Timer
  function EasterBannerTimer(usePDT = false) {
    const timerElement = $('.easter-banner__timer-value');
    if (!timerElement.length) return;

    const endDate = new Date('April 25, 2025 23:59:59').getTime();

    function updateTimer() {
      // If using PDT, adjust time by calculating PDT from UTC
      const now = usePDT
        ? new Date().getTime() + (new Date().getTimezoneOffset() * 60000) - (7 * 3600000)
        : new Date().getTime();

      const timeLeft = endDate - now;
      if (timeLeft <= 0) return timerElement.parent().hide();

      const days = Math.floor(timeLeft / 86400000);
      const hours = Math.floor(timeLeft % 86400000 / 3600000);
      const minutes = Math.floor(timeLeft % 3600000 / 60000);
      const seconds = Math.floor(timeLeft % 60000 / 1000);

      timerElement.text(days > 0
        ? `${days} Days ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        : `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }


  // Initialize section code
  if ($('.announcement__timer').length > 0) {
    AnnouncementTimer();
    $('.announcement__text a').on('click', function (e) {
      e.preventDefault();
      var text = $(this).text().trim();
      copyToClipboard(text);
      log.collapse(text, 'Copied to Clipboard');
    });
  }

  // Initialize Easter Banner Timer
  if ($('.easter-banner__timer-value').length > 0) {
    // Pass true to use PDT timezone, false or nothing to use local time
    EasterBannerTimer(true);
  }

  $('.ScrollToProduct').on('click', function (e) {
    e.preventDefault();
    const offsetTop = $('#product-main').offset().top - 160;
    $('html, body').animate({
      scrollTop: offsetTop
    }, 600);
  });

  $('.AddToCart').on('click', function (e) {
    e.preventDefault();
    const variantId = $(this).data('id');
    $.post('/cart/add.js', {
      items: [{ id: variantId, quantity: 1 }]
    }, function (response) {
      log.collapse(response, 'Added to Cart', 'success');
      theme.ajaxCart.update();
    }).fail(function (response) {
      log.collapse(response, 'Add to Cart Failed', 'error');
    });
  });

  $(".accordion > .accordion-item").children(".accordion-panel").slideUp();
  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item > .accordion-thumb").click(function () {
    var $item = $(this).closest(".accordion-item");
    $item.siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
    if ($item.hasClass("is-active")) {
      $item.removeClass("is-active").children(".accordion-panel").slideUp("ease-out");
    } else {
      $item.addClass("is-active").children(".accordion-panel").slideDown("ease-out");
    }
  });


  // PDP Popup Upsell
  if ($('.popup-upsell__button-atc').length > 0) {
    log.collapse(true, 'Popup Upsell Exists');
    function addToCartPopup($popupBtn) {
      $('.popup-upsell:not(body)').removeClass('active');

      const $button = $popupBtn || $('.popup-upsell__button-atc');
      const upsellId = $button.data('id');

      // Get mainId from URL parameter or data attribute
      const urlParams = new URLSearchParams(window.location.search);
      const mainId = urlParams.get('variant') || $button.data('main-id');
      // Get selling plan from URL parameter
      const mainSellingId = urlParams.get('selling_plan') || undefined;

      const items = [
        { id: mainId, quantity: 1, selling_plan: mainSellingId },
      ];
      if ($popupBtn) items.push({ id: upsellId, quantity: 1 });

      log.collapse(items, 'Add to Cart');

      $.post('/cart/add.js', {
        items
      }, function (response) {
        theme.ajaxCart.update()
      }).fail(function (response) {
        log.collapse(response, 'Add to Cart Failed', 'error');
      });
    }

    async function checkIfUpsellInCart() {
      const cart = await window._pf_getCart();
      const cartItems = cart.items;
      const upsellId = $('.popup-upsell__button-atc').data('id');
      const upsellInCart = cartItems.some(item => item.id === upsellId);
      log.collapse({ upsellInCart, cartItems, upsellId }, 'Upsell in Cart');
      return upsellInCart;
    }

    $('.product-single__add-to-cart .btn--add-to-cart').on('click', async function (e) {
      e.preventDefault();
      const upsellInCart = await checkIfUpsellInCart();
      if (!upsellInCart) {
        $('.popup-upsell:not(body)').addClass('active');
        $(".accordion > .accordion-item").children(".accordion-panel").slideUp();
        $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
      } else {
        addToCartPopup();
      }
    });

    $('.popup-upsell__button-atc').on('click', function (e) {
      e.preventDefault();
      addToCartPopup($(this));
    });

    $('.popup-upsell__button-decline').on('click', function (e) {
      e.preventDefault();
      addToCartPopup();
    });
  }


  // ----------------------- Handle Modals -----------------------
  function handleModal(modalSelector, triggerSelector, closeSelector) {
    const $modal = $(modalSelector);
    let lastScrollY = null;

    // Open modal
    $(triggerSelector).on('click', function () {
      lastScrollY = window.scrollY;
      $modal.addClass('active').attr('aria-hidden', 'false').fadeIn();
      $('body').addClass('no-scroll');
      $('#main').css({
        'z-index': '21',
        'position': 'relative'
      });
    });

    // Close modal
    $('.modal-close, .modal-overlay,' + closeSelector).on('click', function () {
      $modal.removeClass('active').attr('aria-hidden', 'true').fadeOut();
      $('body').removeClass('no-scroll');
      $('#main').css({
        'z-index': 'unset',
        'position': 'unset'
      });
      if (lastScrollY !== null) setTimeout(() => window.scrollTo({ top: lastScrollY, behavior: 'instant' }), 10);
    });
  }

  // Initialize modals
  // handleModal('#pdp-main__modal', '.pdp-main__quantity-gift-modal-trigger');
  const giftModalTrigger = document.querySelectorAll('.pdp-main__quantity-gift-modal-trigger');
  giftModalTrigger.forEach(trigger => {
    const modalId = trigger.getAttribute('aria-controls');
    log.collapse({ trigger, modalId }, 'Gift Modal Trigger', 'success');
    handleModal(`#${modalId}`, trigger, `.modal-cta-close`);
  });
});
